import axios from 'axios';
import RestService from '../../helpers/RestService';

axios.defaults.headers.common = {
  'Accept': 'application/json, text/plain',
  'X-CSRF-Token': RestService.getCsrfToken(),
  'X-Requested-With' : 'XMLHttpRequest',
};

axios.defaults.headers.post['Content-Type'] = 'application/json';

export async function getQuiz(id) {
  
  try {
    const {data} = await axios.get('/api/quiz/get',{params: {id}});
    if(data.errcode == 200) {
      return data.payload;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}

export async function getStudentAnswer(id) {
  
  try {
    const {data} = await axios.get('/api/quiz/get',{params: {id}});
    if(data.errcode == 200) {
      return data.payload;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}

export async function getRooms() {
  
  try {
    const {data} = await axios.get('/api/rooms/get-by-owner');
    if(data.errcode == 200) {
      return data.payload;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}

export async function getCategories() {
  
  try {
    const {data} = await axios.post('/categories/full');
    if(data.errcode == 200) {
      return data.categories;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}

export async function deleteQuestionQuiz(body) {
  
  try {
    const {data} = await axios.post('/api/quiz/questions-delete', body);
    if(data.errcode == 200) {
      return data.categories;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}

export async function getSubjects() {
  
  try {
    const {data} = await axios.post('/subject/list');
    if(data.errcode == 200) {
      return data.subjects;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}

export async function getBranch() {
  
  try {
    const {data} = await axios.post('/branch/full');
    if(data.errcode == 200) {
      return data.branch;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}

export async function getSource() {
  
  try {
    const {data} = await axios.post('/source/full');
    if(data.errcode == 200) {
      return data.source;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}

export async function getSubcategories() {
  
  try {
    const {data} = await axios.post('/subcategories/full');
    if(data.errcode == 200) {
      return data.subcategories;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}

export async function updateQuiz(body) {
  
  try {
    const {data} = await axios.post('/api/quiz/patch', {
      ...body,
      active: body.active ? 1 : 0,
      active_from: moment(body.active_from).unix(),
      active_to: moment(body.active_to).unix(),
    });
    if(data.errcode == 200) {
      return data.payload;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Quiz/actions.js